import { useEffect, useState } from "react";
import { getGoogleApiKey } from "../lib/OptionListApi";

/*
 * The Google Maps key, fetched once per page load and shared by every map. Kept in memory only:
 * unlike the other reference data it is not written to sessionStorage. A failed request is not
 * kept, so the next map tries again.
 */
let keyRequest: Promise<string> | null = null;

const loadGoogleApiKey = (): Promise<string> => {
	if (!keyRequest) {
		keyRequest = getGoogleApiKey().then((result) => {
			const key = result?.value ?? "";
			if (!key) keyRequest = null;
			return key;
		});
	}
	return keyRequest;
};

/** Call after the key is changed, so the next map reads the new one. */
export const resetGoogleApiKey = () => {
	keyRequest = null;
};

/** The Google Maps key, or "" until it has loaded. */
const useGoogleApiKey = (): string => {
	const [apiKey, setApiKey] = useState("");

	useEffect(() => {
		let cancelled = false;
		loadGoogleApiKey().then((key) => {
			if (!cancelled) setApiKey(key);
		});
		return () => {
			cancelled = true;
		};
	}, []);

	return apiKey;
};

export default useGoogleApiKey;
